module.exports = __webpack_public_path__ + "static/media/logo.c10b01d6.png";